import { useTranslation } from 'react-i18next';
import { GallerySection } from '@/mocks/galleryData';

interface GallerySectionNavProps {
  sections: GallerySection[];
}

export default function GallerySectionNav({ sections }: GallerySectionNavProps) {
  const { t, i18n } = useTranslation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(`section-${id}`);
    if (el) {
      const offset = 100;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div className="sticky top-16 md:top-20 z-30 bg-black/95 backdrop-blur-md border-b border-white/5 py-3">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex gap-2 overflow-x-auto pb-1">
          {sections.map((sec) => (
            <button
              key={`${sec.id}-${i18n.language}`}
              onClick={() => scrollTo(sec.id)}
              className="flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider whitespace-nowrap transition-all duration-200 cursor-pointer border bg-transparent text-white/60 border-white/10 hover:border-[#F57F25]/40 hover:text-[#F57F25]"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${sec.icon || 'ri-image-line'} text-xs`}></i>
              </div>
              {sec.labelKey && t(sec.labelKey) !== sec.labelKey ? t(sec.labelKey) : (sec.title || sec.name)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
